import { styled } from '@stitches/react'
import { CrossmintPayButton_DEPRECATED as CrossmintPayButton } from '@crossmint/client-sdk-react-ui'

// NOTE: Needed to override Crossmint Pay Button styles using !important
const StyledCrossmintPayButtonWrapper = styled(CrossmintPayButton, {
  backgroundColor: '$neutralGray400 !important',
  fontWeight: '600 !important',
  fontSize: '16px !important',
  borderRadius: '6px !important',
  '&:hover': {
    backgroundColor: '$neutralGray500 !important',
  },
  '&:disabled': {
    backgroundColor: '$neutralGray600 !important',
  },
  '&:disabled > span': {
    color: '$neutralGray300 !important',
  },
  width: '100%',
})

const CrossmintPayButtonWrapper: React.FC<
  React.ComponentProps<typeof CrossmintPayButton>
> = (props) => {
  return (
    <StyledCrossmintPayButtonWrapper
      {...props}
    />
  )
}

export default CrossmintPayButtonWrapper
